import React, { useState } from 'react';
import { toast } from 'sonner';
import { desktopApi } from '../lib/desktopApi';

const ChangePassword = ({ forced = false, onDone, onLogout }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Les deux saisies ne correspondent pas');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await desktopApi.changeOwnPassword(currentPassword, newPassword);
      toast.success('Mot de passe modifié');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      if (onDone) onDone();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Impossible de modifier le mot de passe');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="mx-auto w-full max-w-md space-y-4" data-testid="change-password">
      <div>
        <h2 className="text-2xl font-bold uppercase">
          {forced ? 'Choisissez votre mot de passe' : 'Changer mon mot de passe'}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          12 caractères minimum, avec une majuscule, une minuscule, un chiffre et un caractère spécial.
        </p>
      </div>
      <label className="block text-sm font-medium">
        {forced ? 'Mot de passe provisoire reçu' : 'Mot de passe actuel'}
        <input
          type="password"
          autoComplete="current-password"
          value={currentPassword}
          onChange={(event) => setCurrentPassword(event.target.value)}
          className="mt-1 h-12 w-full rounded-md border border-input bg-transparent px-3 text-base"
          data-testid="input-current-password"
          required
        />
      </label>
      <label className="block text-sm font-medium">
        Nouveau mot de passe
        <input
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          className="mt-1 h-12 w-full rounded-md border border-input bg-transparent px-3 text-base"
          data-testid="input-new-password"
          required
        />
      </label>
      <label className="block text-sm font-medium">
        Confirmation
        <input
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          className="mt-1 h-12 w-full rounded-md border border-input bg-transparent px-3 text-base"
          data-testid="input-confirm-password"
          required
        />
      </label>
      {error && <p className="text-sm text-red-300" data-testid="password-change-error">{error}</p>}
      <button
        type="submit"
        disabled={busy}
        className="h-12 w-full rounded-md bg-primary font-semibold text-primary-foreground disabled:opacity-50"
        data-testid="btn-change-password"
      >
        {busy ? 'Enregistrement...' : 'Enregistrer le mot de passe'}
      </button>
      {forced && onLogout && (
        <button
          type="button"
          onClick={onLogout}
          className="h-12 w-full rounded-md bg-secondary font-semibold text-secondary-foreground"
          data-testid="btn-logout-password"
        >
          Se déconnecter
        </button>
      )}
    </form>
  );
};

export default ChangePassword;
